import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-family: ${theme.font.comfortaa};
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    margin: 14px 8px -72px 90px;
    width: 100%;
    max-width: 1284px;

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    ${media.lessThan('small')`
      max-width: 270px;
    `}
  `}
`

export const CardContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 1284px;
    height: auto;
    margin: 82px 8px 40px 90px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius};

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}
  `}
`

export const InputContainer = styled.div`
  margin: 36px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;

  ${media.lessThan('medium')`
    padding: 0 12px;
    grid-template-columns: repeat(2, 1fr);

    .button-save-password {
      > svg {
        display: none;
      }
    }
  `}

  ${media.lessThan('small')`
    padding: 0 20px;
    grid-template-columns: repeat(1, 1fr);
  `}
`

export const NewPasswordButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 83px;

  .button-save-password {
    position: relative;
    height: 48px;
    width: 358px;

    > svg {
      position: absolute;
      left: 25px;
    }
  }

  ${media.lessThan('medium')`
    .button-save-password {
      margin: 0 50px;

      > svg {
        display: none;
      }
    }
  `}
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 60px;

  > button {
    position: relative;
    width: 46%;

    > svg {
      position: absolute;
      left: 25px;
    }
  }

  ${media.lessThan('medium')`
    > button {
      width: 80%;
    }
  `}
`
